import { createDeferredEditorHook } from '../shared/deferred-editor'

// Public types ----------------------------------------------------------------

export type CodeEditorHost = {
  readonly el: HTMLElement
  readonly handleEvent: (
    name: string,
    callback: (payload: unknown) => void
  ) => unknown
  readonly pushEvent: (
    event: string,
    payload: Record<string, unknown>,
    callback?: (reply: unknown, ref: number) => unknown
  ) => unknown
}

// Constants -------------------------------------------------------------------

const EVENTS = [
  'editor:set-config',
  'editor:set-context',
  'editor:set-data-previews',
  'editor:set-value'
] as const

// Public hook -----------------------------------------------------------------

export const FacadeCodeEditor = createDeferredEditorHook<CodeEditorHost>(
  EVENTS,
  async (host) => {
    const { mountEditor } = await import('./engine')

    return () => mountEditor(host)
  }
)
